import countries, { formatPopulation } from './countries';

export const formatArea = (n) => Math.round(n).toLocaleString('en-US');

export const getMetricLabel = (entry) => {
  if (entry.metric === 'area') return 'Territory size';
  return 'Population';
};

export const getMetricPromptWord = (entry) => {
  if (entry.metric === 'area') return 'territory size';
  return 'population';
};

export const toNumericValue = (value) => {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (value == null) return NaN;
  const parsed = Number(String(value).replace(/,/g, '').trim());
  return Number.isFinite(parsed) ? parsed : NaN;
};

export const getEntryValue = (entry) => toNumericValue(entry?.value);

export const getEntryKey = (entry) => entry.key;

export const formatEntryValue = (entry, value) => {
  const n = toNumericValue(value);
  if (entry.metric === 'area') return formatArea(n);
  return formatPopulation(Math.round(n));
};

export const buildComparisonPool = () => {
  const entries = [];

  countries.forEach((country) => {
    entries.push({
      key: `${country.code}-population`,
      sourceKind: 'country',
      metric: 'population',
      name: country.name,
      code: country.code,
      value: toNumericValue(country.population),
    });

    const area = toNumericValue(country.area);
    if (Number.isFinite(area) && area > 0) {
      entries.push({
        key: `${country.code}-area`,
        sourceKind: 'country',
        metric: 'area',
        name: country.name,
        code: country.code,
        value: area,
      });
    }
  });

  return entries;
};

export const pickFromPool = (pool, excludeKeys = []) => {
  const exclude = new Set(excludeKeys);
  const available = pool.filter((entry) => !exclude.has(entry.key));
  const source = available.length ? available : pool;
  return source[Math.floor(Math.random() * source.length)];
};

export const pickComparisonPair = (pool) => {
  const left = pickFromPool(pool);
  const leftValue = getEntryValue(left);
  const oppositeMetric = pool.filter(
    (entry) =>
      entry.metric !== left.metric &&
      entry.key !== left.key &&
      getEntryValue(entry) !== leftValue
  );
  const useMixed = oppositeMetric.length > 0 && Math.random() < 0.55;
  let right = useMixed
    ? oppositeMetric[Math.floor(Math.random() * oppositeMetric.length)]
    : pickFromPool(pool, [left.key]);
  let guard = 0;
  while (getEntryValue(right) === leftValue && guard < 20) {
    right = pickFromPool(pool, [left.key, right.key]);
    guard += 1;
  }
  return { left, right };
};

export const pickNextComparison = (pool, current, extraExclude = []) => {
  const exclude = [current.key, ...extraExclude];
  const currentValue = getEntryValue(current);
  const oppositeMetric = pool.filter(
    (entry) =>
      entry.metric !== current.metric &&
      !exclude.includes(entry.key) &&
      getEntryValue(entry) !== currentValue
  );
  const useMixed = oppositeMetric.length > 0 && Math.random() < 0.55;
  let next = useMixed
    ? oppositeMetric[Math.floor(Math.random() * oppositeMetric.length)]
    : pickFromPool(pool, exclude);
  let guard = 0;
  while (getEntryValue(next) === currentValue && guard < 20) {
    next = pickFromPool(pool, [...exclude, next.key]);
    guard += 1;
  }
  return next;
};
